/**
 * StatCards — 3 summary stat cards for the main dashboard.
 */

const StatCards = ({ statData, loading }) => {
    if (loading) {
        return (
            <div className="md-stat-row">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="md-stat-card">
                        <div className="md-stat-card__value" style={{ color: 'var(--color-text-muted)' }}>—</div>
                        <div className="md-stat-card__label">Loading...</div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="md-stat-row">
            <div className="md-stat-card">
                <div className="md-stat-card__value">{statData?.avg_daily_events ?? 0}</div>
                <div className="md-stat-card__label">Avg Daily Alarms</div>
            </div>
            <div className="md-stat-card">
                <div className="md-stat-card__value">{statData?.avg_response_time ?? '0.0'} min</div>
                <div className="md-stat-card__label">Avg Response Rate</div>
            </div>
            <div className="md-stat-card">
                <div className="md-stat-card__value">{statData?.percent_events_over_20 ?? '0.0'}%</div>
                <div className="md-stat-card__label">Alarms Over 20 Min</div>
            </div>
        </div>
    );
};

export default StatCards;
